module.exports = __webpack_public_path__ + "img/0.6072b3c6.png";